// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';
import * as React from 'react';
import { Box, Typography } from '../../lib/base';

export interface PlantingContainerData {
  readonly id: string;
  readonly trays_rounded: string;
  readonly yield_per_tray_ounces: string;
  readonly crop?: {
    readonly crop_name: string;
    readonly yield_unit: string;
  } | null;
  readonly extra?: string;
}

const getAmount = (planting: PlantingContainerData) => {
  const yieldNum = utils.convert({
    inputUnit: 'ounces',
    outputUnit: planting.crop?.yield_unit ?? 'ounces',
    quantity: Number.parseFloat(planting.yield_per_tray_ounces),
  });

  const amount = Number.parseFloat(planting.trays_rounded) * yieldNum;
  const isGrams = planting.crop?.yield_unit === 'grams';
  return `${utils.round(amount, isGrams ? 1 : 0)} ${isGrams ? 'g' : 'oz'}`;
};
export function PlantingListContainer({
  plantingsIn,
  title,
  showAmount,
  addPadding = false,
}: {
  plantingsIn: PlantingContainerData[];
  title: string;
  showAmount: boolean;
  addPadding?: boolean;
}) {
  return (
    <>
      <Typography>{title}</Typography>
      <Box sx={{ pt: addPadding ? 1 : 0 }}>
        <ul>
          {plantingsIn.map((planting) => (
            <li key={planting.id}>
              <Typography key={planting.id}>
                {planting.crop?.crop_name ?? 'Crop Not Found'} - {planting.trays_rounded} trays
                {showAmount ? ` - ${getAmount(planting)}` : ''}
                {planting.extra && ` - ${planting.extra}`}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    </>
  );
}
